export type ActiveTripByIdRecord = {
  _id?: string;
  mergedTripId?: string | null;
};

export type ActiveTripByIdParams = {
  tripId: string;
  showStandaloneAndMergedTrips: boolean;
};

export function getActiveTripByIdParams(
  trip: ActiveTripByIdRecord | null | undefined,
  clientTripMergeEnabled: boolean,
  fallbackId = '',
): ActiveTripByIdParams {
  const hasMergedTripId = !!trip?.mergedTripId;
  const showStandaloneAndMergedTrips = hasMergedTripId && !!clientTripMergeEnabled;

  if (showStandaloneAndMergedTrips) {
    return {
      tripId: trip?.mergedTripId as string,
      showStandaloneAndMergedTrips: true,
    };
  }

  return {
    tripId: trip?._id || fallbackId,
    showStandaloneAndMergedTrips: false,
  };
}
